import { render, staticRenderFns } from "./productcenterxgj.vue?vue&type=template&id=1ede3d98&scoped=true&"
import script from "./productcenterxgj.vue?vue&type=script&lang=js&"
export * from "./productcenterxgj.vue?vue&type=script&lang=js&"
import style0 from "./productcenterxgj.vue?vue&type=style&index=0&id=1ede3d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede3d98",
  null
  
)

export default component.exports